import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import SearchBar from "../../common/Search";
import { useAuth } from "../../Providers/AuthProvider";
import Skeleton from "@mui/material/Skeleton";
import {
  useTourList,
  useTourListActions,
} from "../../Providers/TourListProvider";
import { useUser } from "../../Providers/UserProvider";
import { GetPackageList } from "../../services/GetPackageListService";
import Filter from "../Filter/Filter";
import TourItem from "../TourItem/TourItem";
import CallToPage from "../CallToPage/CallToPage";
import "animate.css";
import TrackVisibility from "react-on-screen";
import { useQuery } from "@tanstack/react-query";
import Spinner from "../spinner/Spinner";

const TourLists = () => {
  const [searchValue, setSearchValue] = useState("");
  const { stateAuth } = useAuth();
  const { dispatch, setIsLoading, setError } = useTourListActions();
  const user = useUser();
  const floatingCompanyId = user.FloatingCompanyId;

  const { tourlistsContext, tourState } = useTourList();
  const [activeTab, setActiveTab] = useOutletContext();

  // const requestData = {
  //   supplierId: floatingCompanyId,
  //   State: tourState,
  // };
  // const header = {
  //   headers: {
  //     token: stateAuth,
  //   },
  // };

  const { isLoading, data, error } = useQuery(["tourListsData"], () =>
    GetPackageList(
      {
        supplierId: floatingCompanyId,
        State: tourState,
      },
      {
        headers: {
          token: stateAuth,
        },
      }
    )
  );

  useEffect(() => {
    console.log({ data });
    if (data) {
      dispatch({ type: "INITIALIZE_CART", fetchedData: data.data.Value });
      dispatch({
        type: "STATE_TOUR",
        selectedOption: { value: 0, label: "تور های فعال" },
      });
    }
    setActiveTab(1);
  }, [data]);

  const renderTools = () => {
    if (isLoading) {
      return (
        <div className="mx-4 mt-4">
          <div>
            <Skeleton
              animation="wave"
              className="!h-80 md:!h-11 !origin-top !scale-100 !mb-4"
            />
          </div>
          <div>
            <Skeleton
              animation="wave"
              className="!h-80 md:!h-11 !origin-top !scale-100 !mb-4"
            />
          </div>
          <div>
            <Skeleton
              animation="wave"
              className="!hidden md:!block !h-80 md:!h-11 !origin-top !scale-100 !mb-4"
            />
          </div>
          <div>
            <Skeleton
              animation="wave"
              className="!hidden md:!block !h-80 md:!h-11 !origin-top !scale-100 !mb-4"
            />
          </div>
          <div>
            <Skeleton
              animation="wave"
              className="!hidden md:!block !h-80 md:!h-11 !origin-top !scale-100 !mb-4"
            />
          </div>
          <div>
            <Skeleton
              animation="wave"
              className="!hidden md:!block !h-80 md:!h-11 !origin-top !scale-100 !mb-4"
            />
          </div>
          <div>
            <Skeleton
              animation="wave"
              className="!hidden md:!block !h-80 md:!h-11 !origin-top !scale-100 !mb-4"
            />
          </div>
        </div>
      );
    }
    if (error) {
      return <div>{error}</div>;
    }
    return tourlistsContext.tourlists.map((tourItem, index) => (
      <TourItem key={tourItem.Id} tourItem={tourItem} index={index} />
    ));
  };
  return (
    <TrackVisibility once>
      {({ isVisible }) =>
        isVisible && (
          <section className="shadow-lg rounded-md border border-stone-100 bg-white animate__animated animate__fadeIn">
            <div className="md:sticky md:top-0 bg-white">
              <div className="bg-orangeKite text-white px-4 py-2">
                <h2>لیست تورها</h2>
              </div>
              <div className="px-4 flex flex-col md:flex-row md:flex-wrap gap-2 my-4 relative">
                <Filter
                  searchValue={searchValue}
                  setSearchValue={setSearchValue}
                />
                <SearchBar
                  searchValue={searchValue}
                  setSearchValue={setSearchValue}
                />
                <div className="w-full xl:w-24 h-8 flex items-center xl:absolute xl:left-4 xl:bottom-0">
                  <CallToPage
                    address="AddPackage"
                    text="افزودن تور"
                    bGColor="bg-darkGreenKite"
                    hoverBgColor="bg-orangeKite"
                  />
                </div>
              </div>
              <div className="hidden md:flex gap-1 mx-4 px-1 py-2 rounded-md bg-lightGreenKite text-white text-sm">
                <div className="w-[12%] hidden md:flex items-center justify-center text-xs">
                  نوع تور
                </div>
                <div className="border-l-2 border-white"></div>
                <div className="w-[30%] flex items-center justify-center">
                  عنوان تور
                </div>
                <div className="border-l-2 border-white"></div>
                <div className="w-[12%] flex items-center justify-center text-xs">
                  شماره تور
                </div>

                <div className="border-l-2 border-white"></div>
                <div className="w-[12%] flex items-center justify-center text-xs">
                  تاریخ ثبت تور
                </div>
                <div className="border-l-2 border-white"></div>
                <div className="w-[16%] flex items-center justify-center">
                  اعتبار پکیج
                </div>
                <div className="border-l-2 border-white"></div>
                <div className="w-[12%] flex items-center justify-center text-xs">
                  وضعیت
                </div>
                <div className="border-l-2 border-white"></div>
                <div className="w-[6%] flex items-center justify-center">
                  عملیات
                </div>
              </div>
            </div>
            <div>{renderTools()}</div>
          </section>
        )
      }
    </TrackVisibility>
  );
};

export default TourLists;
